import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
//import { OrderPlanner } from '../../../common/OrderPlanner';
//import { PurchaseOrderService } from '../../../services/index';
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { agentOutwardService } from "../../../services/agentoutward.service";

@Component({
  selector: "addEditAgentOutward",
  templateUrl: "./addEditAgentOutward.html",
})
export class addEditAgentOutwardComponent {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  seasonList: any;
  widthList: any[];
  invoicedata: any = {};
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  mode: string;
  saveEvent: any;
  agentList: any;
  reasonList = [
    {
      type: "WASHING",
    },
    {
      type: "STAINING",
    },
    {
      type: "REWORK",
    },
  ];
  stockType: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  OutwardType = ["FRESH", "DAMAGE"];
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.to_sale_type = val["to_sale_type"];
    this.saveEvent = val["data"].tabevent;
    let invoicedata = Object.assign({}, val["data"]);
    this.invoicedata = invoicedata;

    if (this.mode == "Edit") {
      this.editInvoiceList();
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private agentowservice: agentOutwardService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      invoiceList: [],
    };
  }

  ngOnInit() {
    this.getstockType();

    this.tableScroll();
    this.invoicedata.mode = this.mode;
    if (this.mode == "Add") {
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAutoNumber();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#name").focus();
    }, 100);
  }

  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }

  onDeleteRow($event, fld, bc, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length > 1) {
          that.data.invoiceList.splice(ind, 1);
          that.calctot();
        }
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    this.agentowservice.getAuto().then((res: any) => {
      this.invoicedata.ref_no = res;
    });
  }
  getstockType() {
    this.stockType = [
      {
        type: "R & D",
      },
      {
        type: "FAIR",
      },
      {
        type: "SALES PERSON",
      },
      {
        type: "CONFERENCE",
      },
      {
        type: "SUSPENSE",
      },
      {
        type: "FACTORY",
      },
    ];
  }
  onSelectgetstockType() {
    let types = this.invoicedata.type;
    if (types == "SALES PERSON" || types == "SUSPENSE") {
      $("#name").focus();
      this.getSalesAgent();
    } else if (types == "R & D" || types == "FAIR" || types == "CONFERENCE") {
      $("#code").focus();
    }
  }
  onSelectAgentName(name) {
    let agentlist = _.filter(this.agentList, { name: name });
    this.invoicedata.agent_id = agentlist[0]["genLedid"];
    $("#code").focus();
  }

  getSalesAgent() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.agentowservice.getSalesAgent(params).then((res: any) => {
      this.agentList = res;
    });
  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }

  checkBarcode(code) {
    if (code.length == 7) {
      let params = {
        barcode: code,
      };
      for (let i = 0; i < this.data.invoiceList.length; i++) {
        code = parseInt(code);
        this.data.invoiceList[i].barcode = parseInt(
          this.data.invoiceList[i].barcode
        );
        if (this.data.invoiceList[i].barcode == code) {
          setTimeout(() => {
            this.invoicedata.barcode = "";
          }, 500);

          swal("Barcode Already Exists");
          swal({
            title: "Barcode Already Exists",
            timer: 1000,
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
          });
          return;
        }
      }

      this.agentowservice.checkBarcode(params).then((res: any) => {
        if (res.data.length == 0) {
          //   swal("Selected Design is invalid!");
          swal({
            title: "Selected Design is invalid",
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000,
          });
          let invalidData = {
            barcode: code,
            type: "invoice",
          };
          this.invalidList.push(invalidData);
          this.invoicedata.barcode = "";
          return;
        }
        let check_damage = res.data.size.split("");

        let typeCheck: boolean;
        console.log(check_damage);

        if (check_damage.length > 0) {
          if ((check_damage[0] !== "D") && this.invoicedata.outward_type == "FRESH")    
          {
            typeCheck = true;
          } 
          else if ((check_damage[0] == "D") && this.invoicedata.outward_type == "DAMAGE")       
           {
            typeCheck = true;
          }
          
          else {
            typeCheck = false;
          }
        } 
        else if (check_damage.length == 0) {
          typeCheck = false;
        }

        if (!typeCheck) {
          swal("PLEASE SCAN" +" " + this.invoicedata.outward_type +" " + "PCS");
          this.invoicedata.barcode = "";
          return;
        }
        let row = Object.assign(
          {
            f34: 0,
            f36: 0,
            f38: 0,
            f40: 0,
            f42: 0,
            f44: 0,
            f46: 0,
            h34: 0,
            h36: 0,
            h38: 0,
            h40: 0,
            h42: 0,
            h44: 0,
            h46: 0,
          },
          res.data
        );
        row.stockid = res.data.stockid;
    
        if(this.invoicedata.outward_type == "DAMAGE"){
          let temp_size = check_damage.slice(1);
          row.size = temp_size.join("");
          console.log(row.size);
          row[row.size.toLowerCase()] = 1;
        }
        else{
            row[row.size.toLowerCase()] = 1;
        }


        row.fqty =
          row.f34 + row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
        row.hqty =
          row.h34 + row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
        row.totqty = row.hqty + row.fqty;
        this.data.invoiceList.push(row);
        this.calctot();
        this.invoicedata.barcode = "";
      });
    }
  }

  oncheckemptyrow() {
    let design = this.data.invoiceList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.invoiceList = desList;
    this.onSaveInvoice();
  }

  onSaveInvoice(): void {
    let types = this.invoicedata.type;
    let isAgent: number = 1;
    if (types == "SALES PERSON" || types == "SUSPENSE") {
      if (this.invoicedata.agent_name == undefined) {
        swal("Make sure that the sales person name entered");
        isAgent = 0;
      }
    }

    if (isAgent) {
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
      params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
      let that = this;

      swal({
        title: "Are you sure to save this Invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.agentowservice
          .saveUpdateAgentOutwardRecord(params)
          .then(function (res: any) {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  editInvoiceList() {
    if (
      this.invoicedata.type == "SALES PERSON" ||
      this.invoicedata.type == "SUSPENSE"
    ) {
      this.getSalesAgent();
    }
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
    params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
    let that = this;
    // params = {
    //     start: 0,
    //     limit: 100,
    //     page: 1,
    //     aoid: this.invoicedata.aoid,

    // }
    this.agentowservice.getAgentStockDetails(params).then((res: any) => {
      that.data.invoiceList = res.data;
      that.invoicedata.dcdt = res.data[0].aodt;
      that.calctot();
    });
  }

  calctot() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      ftot += parseInt(this.data.invoiceList[i]["fqty"]);
      this.invoicedata.fqty = ftot;
      htot += parseInt(this.data.invoiceList[i]["hqty"]);
      this.invoicedata.hqty = htot;
      tot += parseInt(this.data.invoiceList[i]["totqty"]);
      this.invoicedata.totqty = tot;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/agentOutward/addEditAgentOutward.ts